import { Component, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Status } from '../../../../classes/status.class';
import { StatusService } from '../../../../services/planning/status.service';
import { InputComponent } from '../input/input.component';

@Component({
    selector: 'app-status-input',
    standalone: false,
    templateUrl: './status-input.component.html',
    styleUrl: './status-input.component.scss',
})
export class StatusInputComponent extends InputComponent {
    private statusService = inject(StatusService);

    statusList$: Observable<Status[]>;

    ngOnInit() {
        this.statusList$ = this.statusService.getList(this.field?.statusType);
    }
}
